/* ============================================================
   Modulo Product Lineup — arrow buttons + optional autoplay.

   Carousel mechanics (scroll, snap, swipe, momentum) are
   handled natively by CSS scroll-snap. JS only adds:
   - Arrow buttons that scrollBy(card-width)
   - Optional autoplay that scrollBy on an interval (with loop)
   - Reduced-motion + pause-on-hover safeguards
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLineup(root) {
    if (root.dataset.moduloPlReady === '1') return;
    root.dataset.moduloPlReady = '1';

    var rail = root.querySelector('[data-modulo-pl-rail]');
    if (!rail) return;

    var prevBtns = root.querySelectorAll('[data-modulo-pl-prev]');
    var nextBtns = root.querySelectorAll('[data-modulo-pl-next]');
    var loop = root.dataset.loop === '1';
    var autoplay = root.dataset.autoplay === '1' && !REDUCE;
    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;

    function cardWidth() {
      var first = rail.querySelector('.modulo-pl__tile');
      if (!first) return rail.clientWidth;
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    function atStart() {
      return rail.scrollLeft <= 4;
    }

    function scrollByCards(dir) {
      var w = cardWidth();
      if (loop && dir > 0 && atEnd()) {
        rail.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (loop && dir < 0 && atStart()) {
        rail.scrollTo({ left: rail.scrollWidth, behavior: 'smooth' });
        return;
      }
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    function updateArrowState() {
      if (loop) return;
      for (var i = 0; i < prevBtns.length; i++) {
        if (atStart()) prevBtns[i].setAttribute('disabled', '');
        else prevBtns[i].removeAttribute('disabled');
      }
      for (var j = 0; j < nextBtns.length; j++) {
        if (atEnd()) nextBtns[j].setAttribute('disabled', '');
        else nextBtns[j].removeAttribute('disabled');
      }
    }

    for (var p = 0; p < prevBtns.length; p++) {
      prevBtns[p].addEventListener('click', function () { scrollByCards(-1); });
    }
    for (var n = 0; n < nextBtns.length; n++) {
      nextBtns[n].addEventListener('click', function () { scrollByCards(1); });
    }

    rail.addEventListener('scroll', function () {
      window.clearTimeout(rail._modPlScrollTimer);
      rail._modPlScrollTimer = window.setTimeout(updateArrowState, 80);
    }, { passive: true });

    updateArrowState();

    if (autoplay) {
      var autoplayTimer = null;
      var paused = false;

      function tick() {
        if (paused) return;
        scrollByCards(1);
      }
      function start() {
        if (autoplayTimer) return;
        autoplayTimer = window.setInterval(tick, interval);
      }
      function stop() {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin',   function () { paused = true; });
      root.addEventListener('focusout',  function () { paused = false; });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { threshold: 0.25 });
        io.observe(root);
      } else {
        start();
      }
    }
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-pl]', initLineup);
    } else {
      var els = document.querySelectorAll('[data-modulo-pl]');
      for (var i = 0; i < els.length; i++) initLineup(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
